/**
 * Which company an equipment created inline from a work order should be assigned
 * to, or null to leave it unassigned.
 *
 * The new equipment has to land in the set the picker is offering, or it would be
 * created and then not be selectable. Installations under the tenant restriction
 * list unassigned equipments only, so a new one has to stay unassigned — the
 * installation automation assigns it to the company once the work order claims it.
 * Every other case lists the company's own equipments, so it has to be assigned
 * straight away to show up at all.
 */
export function newAssetCompanyId(
  interventionType: string,
  requiresUnassignedAsset: boolean,
  companyId: string | null,
): string | null {
  return interventionType === 'INSTALLATION' && requiresUnassignedAsset
    ? null
    : companyId;
}
